export const ORDER_STATUS = {
  WAITING_FOR_PAYMENT: 'Waiting for payment',
  IN_PROGRESS: 'In progress',
  PAID_IN_PROGRESS: 'Paid - in progress',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
  IN_REPAIR: 'In repair',
  IN_RETURN: 'In return',
  PARTIALLY_RETURNED: 'Partially returned',
  RETURNED: 'Returned',
} as const;

export type OrderStatus = ValueOf<typeof ORDER_STATUS>;
